// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-results[data-v-915d82ee]{position:absolute;top:100%;left:0;width:100%;backface-visibility:unset;background-color:#232323;border-radius:0 0 8px 8px;transform:none}.search-results.expand-enter-active[data-v-915d82ee]{transition-delay:.2s}.search-results.isLoading[data-v-915d82ee],.search-results.notFound[data-v-915d82ee]{height:200px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
